
































































































import { CognitoUser } from "@aws-amplify/auth";
import { namespace } from "vuex-class";
import { Component, Mixins } from "vue-property-decorator";

import AlertList from "@/components/AlertList.vue";
import HasAlerts from "@/mixins/HasAlerts.vue";

const AuthStore = namespace("auth");

@Component({
  components: { AlertList }
})
export default class CompleteSignUp extends Mixins(HasAlerts) {
  private name: string = "";

  private password: string = "";

  private passwordConfirmation: string = "";

  private status: "Loading" | "Idle" = "Idle";

  @AuthStore.State("raw")
  private user!: CognitoUser | null;

  async finish() {
    try {
      if (this.password !== this.passwordConfirmation) {
        this.flash(
          {
            type: "danger",
            message: "Password and password confirmation do not match"
          },
          { global: false }
        );

        return;
      }

      this.status = "Loading";

      await this.$auth.raw.completeNewPassword(this.user, this.password, {
        name: this.name
      });

      this.$router.push("/login");
    } catch (ex) {
      this.flash(
        {
          type: "danger",
          message: ex.message || ex
        },
        { global: false }
      );
    } finally {
      this.status = "Idle";
    }
  }
}
